module.exports = __webpack_public_path__ + "e66aafcb1d26fe9de61f1197f37ad931.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/neu/steigende-kosten-v2-neu.svg
// module id = 139
// module chunks = 1